var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import * as React from "react";

function SvgIcTime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5223_4703",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5223_4703)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.7493 14.417L13.916 13.2503L10.8327 10.167V6.33366H9.16602V10.8337L12.7493 14.417ZM9.99935 18.8337C8.84657 18.8337 7.76324 18.6149 6.74935 18.1774C5.73546 17.7399 4.85352 17.1462 4.10352 16.3962C3.35352 15.6462 2.75977 14.7642 2.32227 13.7503C1.88477 12.7364 1.66602 11.6531 1.66602 10.5003C1.66602 9.34755 1.88477 8.26421 2.32227 7.25033C2.75977 6.23644 3.35352 5.35449 4.10352 4.60449C4.85352 3.85449 5.73546 3.26074 6.74935 2.82324C7.76324 2.38574 8.84657 2.16699 9.99935 2.16699C11.1521 2.16699 12.2355 2.38574 13.2493 2.82324C14.2632 3.26074 15.1452 3.85449 15.8952 4.60449C16.6452 5.35449 17.2389 6.23644 17.6764 7.25033C18.1139 8.26421 18.3327 9.34755 18.3327 10.5003C18.3327 11.6531 18.1139 12.7364 17.6764 13.7503C17.2389 14.7642 16.6452 15.6462 15.8952 16.3962C15.1452 17.1462 14.2632 17.7399 13.2493 18.1774C12.2355 18.6149 11.1521 18.8337 9.99935 18.8337ZM9.99935 17.167C11.8466 17.167 13.4195 16.5177 14.7181 15.2191C16.0167 13.9205 16.666 12.3475 16.666 10.5003C16.666 8.6531 16.0167 7.08019 14.7181 5.78158C13.4195 4.48296 11.8466 3.83366 9.99935 3.83366C8.15213 3.83366 6.57921 4.48296 5.2806 5.78158C3.98199 7.08019 3.33268 8.6531 3.33268 10.5003C3.33268 12.3475 3.98199 13.9205 5.2806 15.2191C6.57921 16.5177 8.15213 17.167 9.99935 17.167Z",
    fill: "#A6A6A7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTime);
export default __webpack_public_path__ + "static/media/ic-time.a293f7755d9a828a698e6288e0bf72a0.svg";
export { ForwardRef as ReactComponent };